import { Typography } from 'antd'
import { Observer } from 'mobx-react-lite'

import { FormField } from '@/Core/UI/Form'
import { FormRow } from '@/Ship/Components/Form/FormSection'

/**
 * Збережений ПІБ, якого не видно з частин: немає прізвища чи імені (давні запрошення, ERP), а ПІБ
 * інший. Рахується зі збережених значень, тож підказка не зникає, поки поля заповнюють.
 */
export const legacyFullName = (saved: Record<string, any>): string | null => {
    const parts = [saved['firstName'], saved['middleName'], saved['lastName']].map((v) => String(v ?? '').trim())
    const fullName = String(saved['fullName'] ?? '').trim()
    const incomplete = !parts[0] || !parts[2]
    return incomplete && fullName && fullName !== parts.filter(Boolean).join(' ') ? fullName : null
}

/**
 * Прізвище, Ім'я, По-батькові — окремими полями; ПІБ бекенд збирає з них сам.
 * Давній ПІБ одним рядком (див. legacyFullName) показуємо підказкою, щоб було з чого дозаповнити.
 */
export const UserNameFields = ({ formContext }: { formContext: any }) => (
    <>
        <FormRow>
            <FormField name="lastName" />
            <FormField name="firstName" />
            <FormField name="middleName" />
        </FormRow>
        <Observer>
            {() => {
                const legacy = legacyFullName(formContext.initialValues ?? {})
                return legacy ? (
                    <Typography.Text type="secondary" data-testid="legacy-full-name">
                        ПІБ раніше вказано одним рядком: «{legacy}». Заповніть Прізвище та Ім'я.
                    </Typography.Text>
                ) : null
            }}
        </Observer>
    </>
)
